import { getCookie, setCookie, eraseCookie } from 'base/cookie-handling';
import { isChapterStarred, activeChapterURL, generateIsChapterStarred } from 'base/active-chapter';
import { eloquaParams, signupForm, verifyEmailForm, verifyCodeForm, initialStarContentPopup, sendChapterForm, sendChapterFormSecond, linkSentPopup } from 'base/popups';
import { submitFormToEloqua } from 'base/google-recaptcha';
import tippy from 'tippy.js';
import Datepicker from 'vanillajs-datepicker/js/Datepicker';
import es from 'vanillajs-datepicker/js/i18n/locales/es';
import de from 'vanillajs-datepicker/js/i18n/locales/de';
import fr from 'vanillajs-datepicker/js/i18n/locales/fr';
import nl from 'vanillajs-datepicker/js/i18n/locales/nl';
import it from 'vanillajs-datepicker/js/i18n/locales/it';
import pl from 'vanillajs-datepicker/js/i18n/locales/pl';
Object.assign(Datepicker.locales, es, de, fr, nl, it, pl);
import { formValidate } from 'base/form-validation';
const cookiePrefix = larry.cookiePrefix;
const daysToKeepCookie = 180;
const apiPath = "/wp-json/mycontent/v1/";
const contentTypes = ["posts", "pages", "videos"];
const noContentSelector = ".noContent__section";
const connectEmailSelector = ".connectEmail__section";
const loaderMarkup = '<div class="loader"></div>';
const contentSections = {
    posts: ".myArticles__section",
    pages: ".myPages__section",
    videos: ".myVideos__section"
};
const contentAppendSelectors = {
    posts: ".wm-myContent__row.type-articles",
    pages: ".wm-myContent__row.type-pages",
    videos: ".wm-myContent__row.type-videos"
};
const datepickerOptions = {
    autohide: true,
    format: 'yyyy/mm',
    pickLevel: 1,
    showOnClick: true,
    language: larry.lang,
    todayBtn: false,
    todayButton: false,
};
const cookie_formValues = cookiePrefix + 'formvalues';
const cookie_savePathOnSuccess = cookiePrefix + 'saveonsuccess';
const cookie_hashToSetOnSuccess = cookiePrefix + 'hashonsuccess';
const cookie_sendCounter = cookiePrefix + 'sendcount';
const cookie_verify = cookiePrefix + 'verify';
const cookie_authed = cookiePrefix + 'authed';
var currentContentType = function (postType = larry.currentPostType) {
    let returnValue = "";
    switch (postType) {
        case "post":
        case "posts":
            returnValue = "posts";
            break;
        case "page":
        case "pages":
            returnValue = "pages";
            break;
        case "video":
        case "videos":
            returnValue = "videos";
            break;
        default:
            returnValue = "pages";
    }
    return returnValue;
};
export var starredContent = {
    posts: [],
    pages: [],
    videos: []
};
export var isPatientStory = larry.isPatientStory;
export var isFamilyFriends = larry.isFamilyFriends;
export var isAuthed = false;
function setIsAuthed() {
    let authCookieName = cookie_authed;
    let authCookieValue = getCookie(authCookieName);
    if (authCookieValue === null) {
        isAuthed = false;
        console.log('isAuthed:', isAuthed);
        return false;
    }
    isAuthed = true;
    console.log('isAuthed:', isAuthed);
    return true;
}
function hasUnfinishedVerification() {
    let verifyCookieName = cookie_verify;
    let verifyCookieValue = getCookie(verifyCookieName);
    if (verifyCookieValue !== null) {
        console.log('We have an unfinished verification.');
        return true;
    }
    return false;
}
function initialPageLoad() {
    Object.keys(starredContent).forEach(key => {
        let cookieName = cookiePrefix + key;
        let cookieValue = getCookie(cookieName);
        if (cookieValue === null) {
            starredContent[key] = [];
            console.log("No " + cookieName);
        }
        else {
            let permalinks = cookieValue.split(",");
            starredContent[key] = permalinks;
            console.log("Found " + cookieName);
        }
    });
}
function updateFavorites(postType, value, postID) {
    let cookieName = cookiePrefix + postType;
    let cookieValue = getCookie(cookieName);
    if (typeof postID !== 'undefined' && postID !== 0)
        value = value + `{${postID}}`;
    if (cookieValue === null) {
        setCookie(cookieName, value, daysToKeepCookie);
        starredContent[postType] = [value];
        console.log("No " + postType + " cookie. Creating it with this value:", JSON.parse(JSON.stringify(starredContent)));
        if (getCookie(cookie_authed) !== null) {
            var updateDatabase = updateMyContentDB(postType, value).done(updateSucceeded).fail(updateFailed);
        }
    }
    else {
        let permalinks = cookieValue.split(",");
        let permalinkPosition = permalinks.indexOf(value);
        if (permalinkPosition === -1)
            permalinkPosition = permalinks.indexOf(value.replace(/\{(\d+)\}/, ''));
        if (permalinkPosition !== -1)
            permalinks.splice(permalinkPosition, 1);
        else
            permalinks.push(value);
        let updatedCookieValue = permalinks.join(",");
        console.log("Found " + postType + " cookie. Showing before and after values.", cookieValue, updatedCookieValue);
        if (updatedCookieValue == "") {
            console.log("Removed the last value from the cookie. Let's erase it.");
            eraseCookie(cookieName);
        }
        else
            setCookie(cookieName, updatedCookieValue, daysToKeepCookie);
        starredContent[postType] = permalinks;
        if (getCookie(cookie_authed) !== null) {
            var updateDatabase = updateMyContentDB(postType, value).done(updateSucceeded).fail(updateFailed);
        }
        console.log("Update existing cookie", permalinks, value, JSON.parse(JSON.stringify(starredContent)));
    }
}
;
function updateCookies(updateData) {
    starredContent = updateData;
    Object.keys(updateData).forEach(key => {
        console.log(updateData[key]);
        let cookieData = updateData[key].join(",");
        let cookieName = cookiePrefix + key;
        if (cookieData.length > 0)
            setCookie(cookieName, cookieData, daysToKeepCookie);
    });
}
function getMyContent() {
    return jQuery.ajax({
        url: larry.rootUrl + apiPath + 'get',
        type: 'POST',
        processData: false,
        data: JSON.stringify(starredContent),
        dataType: 'json',
        contentType: "application/json; charset=utf-8"
    });
}
function handleMyContentErrors(error) {
    console.error(error);
}
function populateMyContent(myContentData) {
    console.log('Will populate with this data', myContentData);
    function generateItemMarkup(itemData, itemType) {
        if (itemType == "videos") {
            var videoTemplate = `<div class="wm-myContent__col col-12 col-sm-6 col-lg-4">
                    <div class="wm-videoPost">
                        <div class="wm-videoPost__topMeta">
                            <div class="wm-videoPost__image"><img src="${itemData.imageUrl}"></div>
                            <div class="wm-videoPost__title"><a href="${itemData.url}${itemData.anchor}">${itemData.title}</a></div>
                        </div>
                        <div class="wm-videoPost__bottomOptions">
                            <div class="wm-videoPost__icons">
                                <a href="#" title="${larry.strings.tippy.sendLink}" class="sendToMail" data-popupheading="sendVideoToEmail"><i class="far fa-envelope" aria-hidden="true"></i></a>
                                <a href="#" class="toggleFavorite" data-path="${itemData.path}" data-type="${itemType}" data-postid="${itemData.id}" title="${larry.strings.tippy.removeFrom}"><i class="far fa-bookmark marked" aria-hidden="true"></i></a>
                                <a class="wm-dataShareLink" data-share-link="${itemData.url}${itemData.anchor}" title="${larry.strings.tippy.share}"><i class="far fa-share-alt" aria-hidden="true"></i></a>
                            </div>
                            <div class="wm-videoPost__readMore"><a href="${itemData.url}${itemData.anchor}">${larry.strings.common.viewVideo}</a></div>
                        </div>
                    </div>
            </div>`;
            return videoTemplate;
        }
        else if (itemType == "posts") {
            let labelTitle = "";
            if (itemData.label.includes('in-depth'))
                labelTitle = larry.strings.postLabels.inDepth;
            else if (itemData.label.includes('quick-read'))
                labelTitle = larry.strings.postLabels.quickRead;
            var postTemplate = `<div class="wm-myContent__col col-12 col-sm-6 col-lg-4">
                <div class="wm-blogPost">
                    <div class="wm-blogPost__topMeta">
                            <div class="wm-postLabel -${itemData.label}">
                                <div class="wm-postLabel__Icon"></div>
                                <div class="wm-postLabel__Title">${labelTitle}</div>
                            </div>
                                                <div class="wm-blogPost__image"><img src="${itemData.imageUrl}"></div>
                        <div class="wm-blogPost__date">${itemData.date}</div>
                        <div class="wm-blogPost__title"><a href="${itemData.url}${itemData.anchor}">${itemData.title}</a></div>
                        <div class="wm-blogPost__excerpt">${itemData.excerpt}</div>
                    </div>
                    <div class="wm-blogPost__bottomOptions">
                        <div class="wm-blogPost__icons">
                            <a href="#" title="${larry.strings.tippy.sendLink}" class="sendToMail" data-popupheading="sendPostToEmail"><i class="far fa-envelope" aria-hidden="true"></i></a>
                            <a href="#" class="toggleFavorite" data-path="${itemData.path}" data-type="${itemType}" data-postid="${itemData.id}" title="${larry.strings.tippy.removeFrom}"><i class="far fa-bookmark marked" aria-hidden="true"></i></a>
                            <a class="wm-dataShareLink" data-share-link="${itemData.url}${itemData.anchor}" title="${larry.strings.tippy.share}"><i class="far fa-share-alt" aria-hidden="true"></i></a>
                        </div>
                        <div class="wm-blogPost__readMore"><a href="${itemData.url}${itemData.anchor}">${larry.strings.common.readArticle}</a></div>
                    </div>
                </div>
            </div>`;
            return postTemplate;
        }
        else if (itemType == "pages") {
            let subTitle = itemData.subTitle;
            if (subTitle)
                subTitle = " - " + subTitle;
            else
                subTitle = "";
            var pageTemplate = `<div class="wm-myContent__col col-12 col-sm-6 col-lg-4">
                <div class="wm-pagePost">
                    <div class="wm-pagePost__topMeta">
                        <div class="wm-pagePost__image"><img src="${itemData.imageUrl}"></div>
                        <div class="wm-pagePost__title"><a href="${itemData.url}${itemData.anchor}">${itemData.title}${subTitle}</a></div>
                    </div>
                    <div class="wm-pagePost__bottomOptions">
                        <div class="wm-pagePost__icons">
                            <a href="#" title="${larry.strings.tippy.sendLink}" class="sendToMail" ><i class="far fa-envelope" aria-hidden="true"></i></a>
                            <a href="#" class="toggleFavorite" data-path="${itemData.path}" data-type="${itemType}" data-postid="${itemData.id}" title="${larry.strings.tippy.removeFrom}"><i class="far fa-bookmark marked" aria-hidden="true"></i></a>
                            <a class="wm-dataShareLink" data-share-link="${itemData.url}${itemData.anchor}" title="${larry.strings.tippy.share}"><i class="far fa-share-alt" aria-hidden="true"></i></a>
                        </div>
                        <div class="wm-pagePost__readMore"><a href="${itemData.url}${itemData.anchor}">${larry.strings.common.goToPage}</a></div>
                    </div>
                </div>
            </div>`;
            return pageTemplate;
        }
        return "Error";
    }
    Object.keys(myContentData).forEach(key => {
        let itemsHTML = "";
        myContentData[key].forEach((postObject) => {
            itemsHTML += generateItemMarkup(postObject, key);
        });
        let targetElement = document.querySelector(contentAppendSelectors[key]);
        targetElement.innerHTML = itemsHTML;
    });
}
function updateMyContentDB(postType, value) {
    let data = {
        type: postType,
        value: value,
        all: starredContent,
        sendCount: sendCounter(true)
    };
    return jQuery.ajax({
        url: larry.rootUrl + apiPath + 'update',
        type: 'POST',
        processData: false,
        data: JSON.stringify(data),
        dataType: 'json',
        contentType: "application/json; charset=utf-8",
    });
}
function updateSucceeded(updateData) {
    console.log(updateData);
    if (updateData.update !== false) {
        starredContent = updateData.update;
        updateCookies(updateData.update);
    }
}
function updateFailed(updateFailedData) {
    console.error(updateFailedData);
}
async function getInitialData() {
    let result;
    try {
        result = await jQuery.ajax({
            url: larry.rootUrl + apiPath + 'initial',
            type: 'GET',
            processData: false,
        });
        console.log("getInitialData() result:", result);
        return result;
    }
    catch (error) {
        console.error(error);
    }
}
async function doInitialDataFetch() {
    let getVariables = {};
    if (document.location.toString().indexOf('?') !== -1) {
        var query = document.location
            .toString()
            .replace(/^.*?\?/, '')
            .replace(/#.*$/, '')
            .split('&');
        for (var i = 0, l = query.length; i < l; i++) {
            var aux = decodeURIComponent(query[i]).split('=');
            getVariables[aux[0]] = aux[1];
        }
    }
    if (getVariables.hasOwnProperty("success")) {
        console.log("We've got a successful login.");
        var initialData = await getInitialData();
        if (initialData !== false) {
            if ('sendCount' in initialData) {
                let sendCount = initialData.sendCount;
                delete initialData.sendCount;
                sendCounter(false, sendCount);
            }
            starredContent = initialData;
            updateCookies(initialData);
        }
        let pathToSave = getPathToSaveOnSuccess();
        if (pathToSave) {
            let pathType = pathToSave.type;
            let savedPath = pathToSave.path;
            updateFavorites(pathType, savedPath);
            if (isPatientStory)
                generateIsChapterStarred();
        }
        let hashToInclude = getHashToSetOnSuccess();
        let formCookieValue = getFormValuesFromCookie();
        if (formCookieValue) {
            let inputs = '';
            let formType = '';
            formCookieValue.forEach(element => {
                if (element.name == 'form')
                    formType = element.value;
                else if (element.name == 'dateofSurgery1' && element.value !== '') {
                    let surgeryDate = element.value + '/01';
                    inputs += `<input type="date" name="${element.name}" value="${surgeryDate}" />`;
                }
                else
                    inputs += `<input name="${element.name}" value="${element.value}" />`;
            });
            let formHtml = `<form action="${eloquaParams.url}" method="post" id="wm-form__tempSignupForm">${inputs}<input type="submit" /></form>`;
            eraseCookie(cookie_formValues);
            jQuery(formHtml).hide().appendTo('body');
            submitFormToEloqua('wm-form__tempSignupForm');
            jQuery('#wm-form__tempSignupForm').remove();
        }
        if (hashToInclude)
            window.location.hash = hashToInclude;
    }
    if (getVariables.hasOwnProperty("sendSecondContentSuccess") && getVariables['sendSecondContentSuccess'] === 'true')
        sendCounter(false);
    return true;
}
async function newUserRegistration(formValues) {
    async function doRegistration(formValues) {
        let result;
        try {
            result = await jQuery.ajax({
                url: larry.rootUrl + apiPath + 'auth',
                type: 'POST',
                processData: false,
                data: JSON.stringify(formValues),
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
            });
            return result;
        }
        catch (error) {
            console.error(error);
            return false;
        }
    }
    let registrationResult = await doRegistration(formValues);
    if (registrationResult.hasOwnProperty('verify')) {
        let verifyCookieName = cookie_verify;
        let verifyCookieValue = registrationResult.verify;
        let quarterInDays = 0.25 / 24;
        setCookie(verifyCookieName, verifyCookieValue, quarterInDays);
        return true;
    }
    return false;
}
async function sendContentToEmail(url) {
    let data = {
        link: url,
        sendCount: sendCounter(true)
    };
    async function doSendRequest(data) {
        let result;
        try {
            result = await jQuery.ajax({
                url: larry.rootUrl + apiPath + 'send',
                type: 'POST',
                processData: false,
                data: JSON.stringify(data),
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
            });
            return result;
        }
        catch (error) {
            console.error(error);
            return false;
        }
    }
    let sendContent = await doSendRequest(data);
    if (sendContent !== false) {
        return true;
    }
    return false;
}
function disableInput(target) {
    jQuery(target).prop('disabled', true);
}
function enableInput(target) {
    jQuery(target).prop('disabled', false);
}
export function appendLoader(target) {
    jQuery(loaderMarkup).hide().appendTo(target).slideDown(100);
}
export function removeLoader(target) {
    jQuery(target).slideUp(100, function () {
        jQuery(target).remove();
    });
}
function sendCounter(checkValue, setCount = -1) {
    let cookieName = cookie_sendCounter;
    let cookie = getCookie(cookieName);
    let count;
    if (cookie == null) {
        if (checkValue)
            return 0;
        count = 1;
        if (setCount > -1)
            count = setCount;
        setCookie(cookieName, count.toString(), 180);
    }
    else {
        let count = parseInt(cookie);
        if (checkValue)
            return count;
        count++;
        if (setCount !== -1 && setCount > count)
            count = setCount;
        setCookie(cookieName, count.toString(), 180);
        console.log(count);
    }
    return count;
}
function saveFormValuesToCookie(data) {
    let dataJson = JSON.stringify(data);
    let cookieName = cookie_formValues;
    let quarterInDays = 0.25 / 24;
    setCookie(cookieName, dataJson, quarterInDays);
}
function getFormValuesFromCookie() {
    let cookieName = cookie_formValues;
    let cookieValue = getCookie(cookieName);
    if (cookieValue !== null)
        return JSON.parse(cookieValue);
    return false;
}
function pathToSaveOnSuccess(pathToSave) {
    let dataJson = JSON.stringify(pathToSave);
    let cookieName = cookie_savePathOnSuccess;
    setCookie(cookieName, dataJson, 1);
}
function getPathToSaveOnSuccess() {
    let cookieName = cookie_savePathOnSuccess;
    let cookieValue = getCookie(cookieName);
    if (cookieValue !== null)
        return JSON.parse(cookieValue);
    return false;
}
function hashToSetOnSuccess(hashToSet) {
    if (hashToSet === '')
        return;
    let dataJson = JSON.stringify(hashToSet);
    let cookieName = cookie_hashToSetOnSuccess;
    let quarterInDays = 0.25 / 24;
    setCookie(cookieName, dataJson, quarterInDays);
}
function getHashToSetOnSuccess() {
    let cookieName = cookie_hashToSetOnSuccess;
    let cookieValue = getCookie(cookieName);
    if (cookieValue !== null)
        return JSON.parse(cookieValue);
    return false;
}
(async function ($) {
    function fillTheOptionBoxStar(customPath = false) {
        let currentPath = window.location.pathname + window.location.hash;
        currentPath = currentPath.replace(`/${larry.lang}/`, '');
        if (customPath !== false)
            currentPath = customPath;
        let isStarred = false;
        console.log('We check this content: ', JSON.parse(JSON.stringify(starredContent)));
        Object.keys(starredContent).forEach(key => {
            if (starredContent[key].indexOf(currentPath) !== -1)
                isStarred = true;
            else if (starredContent[key].indexOf(currentPath + '{' + larry.currentPostID + '}') !== -1)
                isStarred = true;
        });
        let starTarget = '.wm-chapterOptionBox .toggleFavorite i, .wm-optionBox .toggleFavorite i';
        if (isStarred) {
            console.log("We have a star, adding bold class.", $(starTarget));
            $(starTarget).addClass('font-weight-bold');
        }
        else if (!isStarred && $(starTarget).hasClass('font-weight-bold')) {
            console.log("Item is not starred, removing bold class.");
            $(starTarget).removeClass('font-weight-bold');
        }
    }
    function fillItemStars() {
        let $stars = $('.toggleFavorite');
        $stars.each(function (index) {
            let starType = currentContentType($(this).data('type'));
            let starPath = $(this).attr('data-path').replace(larry.rootUrl, "");
            starredContent[starType].forEach(value => {
                console.log('Value before regex replace: ', value);
                let reg = /\{(\d+)\}/;
                value = value.replace(reg, '');
                console.log('Value after regex replace: ', value);
                if (value == starPath)
                    $(this).children('i').addClass('font-weight-bold');
            });
        });
    }
    function fillMyContentMenuButton() {
        if (starredContent['posts'].length > 0 || starredContent['pages'].length > 0 || starredContent['videos'].length > 0) {
            jQuery('.my-content-menu-button').addClass('-filled');
        }
        else {
            jQuery('.my-content-menu-button').removeClass('-filled');
        }
    }
    function addNoContent() {
        let visibleSections = [];
        Object.keys(contentSections).forEach(key => {
            if ($(contentSections[key]).is(':visible'))
                visibleSections.push(true);
            else
                visibleSections.push(false);
        });
        console.log('Visible sections', visibleSections);
        if (visibleSections.every(val => val === false))
            $(noContentSelector).slideDown(200);
    }
    function closePopups() {
        let $backdrop = $('.wm-popup__backdrop, .wm-popup__savedContent.new');
        if ($backdrop.is(':visible'))
            $backdrop.fadeOut(200);
    }
    initialPageLoad();
    var gotInitialData = doInitialDataFetch();
    $(document).on('ready', function () {
        fillTheOptionBoxStar();
        fillItemStars();
        fillMyContentMenuButton();
    });
    if (larry.isMyContent) {
        if (await gotInitialData) {
            var isEmpty = Object.values(starredContent).every(x => x.length <= 0);
            if (!isEmpty) {
                var myContentValues = getMyContent().done(populateMyContent).fail(handleMyContentErrors);
            }
            else {
                var myContentValues = false;
            }
        }
        if (await myContentValues) {
            console.log("myContentValues true");
            let hideNoContentSection = false;
            Object.keys(starredContent).forEach(key => {
                if (starredContent[key].length !== 0) {
                    $(contentSections[key]).slideDown(200);
                    hideNoContentSection = true;
                }
            });
            if (hideNoContentSection && $(noContentSelector).is(':visible'))
                $(noContentSelector).slideUp(200);
        }
        $(document).on('ready', function () {
            if (setIsAuthed()) {
                console.log("Sliding up the connect email section");
                $(connectEmailSelector).slideUp(200);
            }
        });
    }
    $(document).on('click', '.toggleFavorite', function (e) {
        e.preventDefault();
        console.log('Clicked toggleFavorite');
        if (larry.isPatientStory)
            isPatientStory = true;
        let type = $(this).data('type');
        let path = $(this).data('path');
        let postID = $(this).data('postid');
        if (path == "" || isFamilyFriends) {
            path = window.location.pathname + window.location.hash;
            postID = larry.currentPostID;
        }
        if (isNaN(postID))
            postID = 0;
        else if (isPatientStory)
            path = activeChapterURL;
        path = path.replace(larry.rootUrl, "");
        console.log("Are we authed?", isAuthed);
        if (hasUnfinishedVerification()) {
            $(verifyCodeForm).hide().appendTo('body').fadeIn(200);
            return false;
        }
        if (!setIsAuthed()) {
            pathToSaveOnSuccess({ type: currentContentType(type), path: path, postID: postID });
            let hash = '';
            if (path !== '') {
                let parts = path.split('#');
                if (parts.length > 1) {
                    hash = '#' + parts.pop();
                }
            }
            if (hash === '')
                hash = window.location.hash;
            hashToSetOnSuccess(hash);
            console.log("Not authed", isAuthed);
            if ($('.wm-popup__savedContent.new').length == 0) {
                $(initialStarContentPopup).hide().appendTo('.entry-content').fadeIn(200);
            }
            else
                $('.wm-popup__savedContent.new').fadeIn(200);
            return false;
        }
        console.log("Update favorites with:", type, path, postID);
        updateFavorites(currentContentType(type), path, postID);
        if (larry.isMyContent) {
            let targetParent = $(this).parents('.myContent__section');
            $(this).parents('.wm-myContent__col').fadeOut(200, function () {
                $(this).remove();
                if (targetParent.find('.wm-myContent__col').length <= 0)
                    targetParent.slideUp(200, function () {
                        addNoContent();
                    });
            });
        }
        if (isPatientStory) {
            fillTheOptionBoxStar(path);
            let currentHash = "#" + activeChapterURL.split('#')[1];
            console.log('currentHash', currentHash);
            isChapterStarred[currentHash] = !isChapterStarred[currentHash];
        }
        else
            fillTheOptionBoxStar();
        fillMyContentMenuButton();
        if ($(this).parents('.wm-chapterOptionBox, .wm-optionBox').length < 1) {
            $(this).children('i').toggleClass('font-weight-bold');
        }
        let tippyContent;
        if (!$(this).children('i').hasClass('font-weight-bold')) {
            tippyContent = larry.strings.tippy.removedFrom;
        }
        else {
            tippyContent = larry.strings.tippy.savedTo;
        }
        this._tippy.setContent(tippyContent);
        this._tippy.show();
    });
    $(document).on('click', '.popupSignup', function (e) {
        e.preventDefault();
        if (hasUnfinishedVerification()) {
            closePopups();
            $(verifyCodeForm).hide().appendTo('body').fadeIn(200);
            return false;
        }
        closePopups();
        $(signupForm).hide().appendTo('body').fadeIn(200);
        const dateField = document.querySelector('input[name="dateofSurgery1"]');
        const datepicker = new Datepicker(dateField, datepickerOptions);
    });
    $(document).on('click', '.popupVerify', function (e) {
        e.preventDefault();
        if (hasUnfinishedVerification()) {
            closePopups();
            $(verifyCodeForm).hide().appendTo('body').fadeIn(200);
            return false;
        }
        closePopups();
        $(verifyEmailForm).hide().appendTo('body').fadeIn(200);
    });
    $(document).on('click', '.wm-popup__close, .closeTrigger', function (e) {
        e.preventDefault();
        $(this).parents('.wm-popup__backdrop').fadeOut(200, function () {
            $(this).remove();
        });
    });
    $(document).on('click', '.wm-popup__backdrop', function (e) {
        e.stopPropagation();
        if ($(e.target).hasClass('wm-popup__backdrop')) {
            $(this).fadeOut(200, function () {
                $(this).remove();
            });
        }
    });
    $(document).on('click', '.wm-form__signup input[type="submit"]', async function (e) {
        e.preventDefault();
        let formData = $('.wm-form__signup :input').serializeArray();
        let formValues = {
            firstname: formData[0].value,
            lastname: formData[1].value,
            email: formData[2].value
        };
        let formIsValid = false;
        let fieldset = $(this).parents('form')[0];
        let validForm = formValidate.validateAll(fieldset);
        if (validForm.length <= 0) {
            $(this).removeClass('-disabled');
            formIsValid = true;
        }
        let actionUrl = $(this).parents('form').prop('action');
        let whichForm = $(this).parents('form').data('form');
        if (whichForm == 'sendSecondContent' && formIsValid) {
            let $dateOfSurgery = $(this).parents('form').find('#date-of-surgery');
            let surgeryDate = $dateOfSurgery.val();
            if (surgeryDate == '') {
                let currentDate = new Date();
                let isoDate = currentDate.toISOString().split('T')[0];
                $dateOfSurgery.val(isoDate);
            }
            else {
                $dateOfSurgery.val(surgeryDate + '/01');
            }
            $(this).parents('form').trigger('submit');
        }
        if (!$(this).hasClass('-disabled') && whichForm !== 'sendSecondContent') {
            disableInput($(this));
            appendLoader($(this).parents('.wm-form__submitColumn'));
            var doNewRegistration = await newUserRegistration(formValues);
            enableInput($(this));
            removeLoader($(this).siblings('.loader'));
        }
        if (doNewRegistration) {
            console.log('Switch popup');
            console.log('formData with actionUrl', formData);
            saveFormValuesToCookie(formData);
            closePopups();
            $(verifyCodeForm).hide().appendTo('body').fadeIn(200);
        }
    });
    $(document).on('click', '.wm-form__verify #submit', async function (e) {
        e.preventDefault();
        let formData = $('.wm-form__verify :input').serializeArray();
        let formValues = {
            email: formData[0].value
        };
        disableInput($(this));
        appendLoader($(this).parents('.wm-form__submitColumn'));
        var doNewVerification = await newUserRegistration(formValues);
        enableInput($(this));
        removeLoader($(this).siblings('.loader'));
        if (doNewVerification) {
            console.log('Switch popup');
            closePopups();
            $(verifyCodeForm).hide().appendTo('body').fadeIn(200);
        }
    });
    $(document).on('click', '.wm-popup__savedContentCloseButton', function () {
        $(this).parents('.wm-popup__savedContent').fadeOut(200);
    });
    $(document).on('click', '.wm-popup__savedContent', function (e) {
        if ($(e.target).hasClass('wm-popup__savedContent')) {
            $(this).fadeOut(200);
        }
    });
    $(document).on('click', '.sendToMail', async function (e) {
        e.preventDefault();
        if (hasUnfinishedVerification()) {
            $(verifyCodeForm).hide().appendTo('body').fadeIn(200);
            return false;
        }
        console.log(this);
        let popupHeading = $(this).data('popupheading');
        let url = $(this).data('path');
        if (!url && $(this).is('i'))
            url = $(this).parent().siblings('.toggleFavorite').data('path');
        if (!url && $(this).parents('.-sendToMail').length)
            url = $(this).parents('.-sendToMail').next('.-addToFavorites').find('.toggleFavorite').data('path');
        if (!url)
            url = $(this).siblings('.toggleFavorite').data('path');
        if (url && !url.includes(larry.rootUrl))
            url = larry.rootUrl.replace(`/${larry.lang}/`, '') + url;
        if (!url)
            url = window.location.href;
        if (setIsAuthed() && !$(this).hasClass('disabled')) {
            $(this).addClass('disabled');
            let count = sendCounter(true);
            if (count == 2) {
                $(sendChapterFormSecond).hide().appendTo('body').fadeIn(200);
                if (popupHeading) {
                    $('.wm-popup__sendChapterHeading').html(larry.strings.common[popupHeading]);
                }
                const dateField = document.querySelector('input[name="dateofSurgery1"]');
                const datepicker = new Datepicker(dateField, datepickerOptions);
            }
            else {
                var sendingContent = await sendContentToEmail(url);
                console.log("Sending content:", sendingContent);
                $(this).removeClass('disabled');
                if (sendingContent !== false) {
                    $(linkSentPopup).hide().appendTo('#page').fadeIn(200);
                }
                else {
                    this._tippy.setContent(larry.strings.tippy.somethingWrong);
                    this._tippy.show();
                }
                sendCounter(false);
            }
        }
        else if (!setIsAuthed()) {
            closePopups();
            $(sendChapterForm).hide().appendTo('body').fadeIn(200);
            if (popupHeading) {
                $('.wm-popup__sendChapterHeading').html(larry.strings.common[popupHeading]);
            }
        }
        $(this).removeClass('disabled');
    });
    $(document).on('change', 'select[name="role"]', function () {
        let $dateOfSurgery = $('.wm-form__dateOfSurgery');
        if (this.value == 'patient') {
            if (!$dateOfSurgery.is(':visible'))
                $dateOfSurgery.slideDown(200);
        }
        else {
            if ($dateOfSurgery.is(':visible'))
                $dateOfSurgery.slideUp(200);
        }
    });
    $(document).on('ready', function () {
        if (setIsAuthed()) {
            tippy('.toggleFavorite', {
                trigger: 'manual',
                onShow(instance) {
                    setTimeout(() => {
                        instance.hide();
                    }, 2000);
                },
                placement: 'bottom'
            });
            tippy('.sendToMail', {
                trigger: 'manual',
                onShow(instance) {
                    setTimeout(() => {
                        instance.hide();
                    }, 2000);
                },
                placement: 'bottom'
            });
        }
        tippy('.toggleFavorite i', {
            placement: 'top',
            content: larry.strings.tippy.saveTo
        });
        tippy('.sendToMail i', {
            placement: 'top',
            content: larry.strings.tippy.sendLink
        });
        tippy('.wm-dataShareLink i, .wm-shareOpenPopup i', {
            placement: 'top',
            content: larry.strings.tippy.share
        });
    });
})(jQuery);
